/**
 * Fall detection buybox ATC (AUD-613).
 *
 * AudienCare-style flow: force selling_plan + optional Wearer Phone properties,
 * then /cart/add.js → cart drawer or checkout.
 */
(function () {
  class WlsnFallDetectionBuybox extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
      this.quantityInput = this.querySelector(".js-wlsn-fd-buybox-quantity-input");
      this.qtyIncrease = this.querySelector(".js-wlsn-fd-buybox-qty-increase");
      this.qtyDecrease = this.querySelector(".js-wlsn-fd-buybox-qty-decrease");
      this.atcButton = this.querySelector(".js-wlsn-fd-buybox-atc");
      this.errorEl = this.querySelector(".js-wlsn-fd-buybox-error");
      this.wearerPhone = this.querySelector("wlsn-fall-detection-wearer-phone");

      this.qtyIncrease?.addEventListener("click", () => this.changeQuantity(1));
      this.qtyDecrease?.addEventListener("click", () => this.changeQuantity(-1));
      this.quantityInput?.addEventListener("change", () => {
        const value = Math.max(1, parseInt(this.quantityInput.value, 10) || 1);
        this.quantityInput.value = String(value);
        if (this.atcButton) this.atcButton.dataset.quantity = String(value);
      });
      this.atcButton?.addEventListener("click", (event) => {
        event.preventDefault();
        this.addToCart();
      });
    }

    changeQuantity(delta) {
      if (!this.quantityInput) return;
      const currentValue = parseInt(this.quantityInput.value, 10) || 1;
      const nextValue = Math.max(1, currentValue + delta);
      this.quantityInput.value = String(nextValue);
      if (this.atcButton) this.atcButton.dataset.quantity = String(nextValue);
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.hidden = !message;
      this.errorEl.textContent = message || "";
    }

    async addToCart() {
      if (!this.atcButton || this.atcButton.disabled) return;

      const sellingPlan = this.sellingPlanInput?.value;
      if (!sellingPlan) {
        this.showError("Subscription plan is not configured for this product.");
        return;
      }

      const properties =
        this.wearerPhone?.getCartProperties?.() ??
        (this.wearerPhone?.validate?.() === false ? null : {});
      if (properties === null) return;

      const payload = {
        id: this.atcButton.dataset.id,
        quantity: this.atcButton.dataset.quantity || this.quantityInput?.value || 1,
        selling_plan: sellingPlan,
      };
      if (Object.keys(properties).length > 0) {
        payload.properties = properties;
      }

      this.showError("");
      this.atcButton.disabled = true;

      try {
        const addResponse = await fetch(`${window.location.origin}/cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!addResponse.ok) {
          const errorBody = await addResponse.json().catch(() => ({}));
          this.showError(
            errorBody.description ||
              errorBody.message ||
              "Could not add subscription to cart. Check inventory and selling plan.",
          );
          return;
        }

        const drawer = document.querySelector("wlsn-cart-drawer");
        if (window.cartType === "cart_drawer" && drawer) {
          drawer.openDrawer?.();
          drawer.setLoading?.(true);
          await drawer.refreshDrawer?.();
          return;
        }

        window.location.href = `${window.location.origin}/checkout?skip_shop_pay=true`;
      } catch (error) {
        console.error("Fall detection ATC error:", error);
        this.showError("Could not add subscription to cart. Please try again.");
      } finally {
        this.atcButton.disabled = false;
      }
    }
  }

  if (!customElements.get("wlsn-fall-detection-buybox")) {
    customElements.define("wlsn-fall-detection-buybox", WlsnFallDetectionBuybox);
  }
})();
